import axios from 'axios';

const api = axios.create({
  baseURL: '',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Перехватчик для обработки ошибок
api.interceptors.response.use(
  response => response,
  error => {
    // Не редиректим на login для самого login эндпоинта
    const isLoginRequest = error.config?.url?.includes('/login');
    
    if (error.response?.status === 401 && !isLoginRequest) {
      // Перенаправляем на страницу входа при ошибке авторизации
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
